var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$route.meta.hideNavigation)?_c('navigation',{attrs:{"mobile":_vm.$vuetify.breakpoint.mdAndDown}}):_vm._e(),_c('v-main',[_c('router-view')],1),_c('message-bar'),_c('cookie-consent'),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }